export default "__VITE_ASSET__86f6c050__"